import script from "./LandingDemoDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./LandingDemoDashboard.vue?vue&type=script&setup=true&lang=js"

import "./LandingDemoDashboard.vue?vue&type=style&index=0&id=b36b50c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b36b50c8"]])

export default __exports__